/**
 * @generated SignedSource<<6241655398eac5a931b37d2099b959bd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CarouselThumb_videoVimeo$data = {
  readonly thumbnail: string | null;
  readonly " $fragmentType": "CarouselThumb_videoVimeo";
};
export type CarouselThumb_videoVimeo$key = {
  readonly " $data"?: CarouselThumb_videoVimeo$data;
  readonly " $fragmentSpreads": FragmentRefs<"CarouselThumb_videoVimeo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CarouselThumb_videoVimeo",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includePlayButton",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "pad",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "size",
          "value": "w100h75"
        }
      ],
      "kind": "ScalarField",
      "name": "thumbnail",
      "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
    }
  ],
  "type": "VideoVimeo",
  "abstractKey": null
};

(node as any).hash = "5065c996fd943b3d925104c1ace17986";

export default node;
